import { Select, Space } from 'antd';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import type { Granularity } from '../../models';
import type { RangeKey } from './useDashboardRange';

interface DashboardRangeControlsProps {
  range: RangeKey;
  granularity: Granularity;
  setRange: (range: RangeKey) => void;
  setGranularity: (granularity: Granularity) => void;
  /** Off for tabs that don't bucket by period — the calendar heatmap is always daily. */
  showGranularity?: boolean;
}

/**
 * Range (and optionally granularity) pickers, rendered inside each tab. They used to sit above the
 * tab strip, which meant a tab could change the visibility of a control outside itself and the
 * calendar showed a granularity picker it silently ignored.
 */
const DashboardRangeControls: React.FC<DashboardRangeControlsProps> = ({
  range,
  granularity,
  setRange,
  setGranularity,
  showGranularity = true
}) => {
  const { tDashboard } = useCustomTranslation();

  return (
    <Space style={{ marginBottom: 16 }} wrap>
      <Select value={range} onChange={setRange} style={{ width: 160 }}>
        <Select.Option value="3m">{tDashboard('range_last90Days')}</Select.Option>
        <Select.Option value="12m">{tDashboard('range_last12Months')}</Select.Option>
        <Select.Option value="all">{tDashboard('range_all')}</Select.Option>
      </Select>
      {showGranularity && (
        <Select value={granularity} onChange={setGranularity} style={{ width: 140 }}>
          <Select.Option value="day">{tDashboard('granularity_day')}</Select.Option>
          <Select.Option value="week">{tDashboard('granularity_week')}</Select.Option>
          <Select.Option value="month">{tDashboard('granularity_month')}</Select.Option>
        </Select>
      )}
    </Space>
  );
};

export default DashboardRangeControls;
